import Vue from 'vue'
import VueGtm from 'vue-gtm'
import BootstrapVue from 'bootstrap-vue'
import store from '@/store'
import router from '@/router'
import '@/scss/custom.scss'
import './../bobcaticons.font'
import appConfig from '@/config'
import App from '@/App.vue'
import oktaAuth from '@/okta'
import OktaVue from '@okta/okta-vue'
import '@okta/okta-auth-js/polyfill'

import commonMixin from '@/mixins/commonMixin'
import {library, dom} from '@fortawesome/fontawesome-svg-core'
import icons from './icons'
import axios from '@/axios'

library.add(icons)
dom.watch()

Vue.config.productionTip = false

Vue.use(OktaVue, {oktaAuth})
Vue.use(BootstrapVue)

Vue.use(VueGtm, {
  id: appConfig.gtmKey,
  defer: false,
  enabled: true,
  loadScript: true,
  vueRouter: router
})

async function getToken() {
  try {
    const token = await Vue.prototype.$auth.tokenManager.get('accessToken')
    return token.accessToken
  } catch (e) {
    return false
  }
}

axios.interceptors.request.use(
  async (config) => {
    const token = await getToken()
    if (token) {
      Object.assign(config.headers, {Authorization: `Bearer ${token}`})
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) { //if page need authorization
    const token = await getToken() //wait for token
    if (!token) next() //allow to redirect to okta

    let features = store.getters['servicelibrary/getFeatures']

    if (Object.keys(features).length === 0) features = await new Promise(resolve => { //wait for features
      const unwatchFetures = store.watch(store => store.servicelibrary.features, () => {
        features = store.getters['servicelibrary/getFeatures']
        if (features) {
          resolve(features)
          unwatchFetures()
        }
      })
    })

    let region = store.getters['servicelibrary/getRegion']

    if (!region) region = await new Promise(resolve => { //wait for region
      let checkRegion = () => {
        let region = store.getters['servicelibrary/getRegion']
        if (region) {
          resolve(region)
          unwatchRegion()
          unwatchUser()
        }
      }
      //watch region
      const unwatchRegion = store.watch(store => store.servicelibrary.region, checkRegion)
      //watch user
      const unwatchUser = store.watch(store => store.servicelibrary.user, checkRegion)
    })

    let featureIsAllowed = !!features['libraryApp' + region]

    featureIsAllowed ? next() : next({
      name: 'Error',
      query: {'redirect': true, 'error': 'featureUnauthorized'}
    })
  } else next() //does not require authentication
})

window.vm = new Vue({
  mixins: [commonMixin(Vue)],
  router,
  store,
  render: h => h(App)
}).$mount('#app')
